import { Component, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal'
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { ActivatedRoute } from '@angular/router';
import * as firebase from 'firebase/app'

import { ToasterService } from 'angular2-toaster';

import { AuthService } from '../../core/auth.service'

//models
import { Bug, BugTypes } from './bugs';

@Component({
  selector: 'app-bugreporting',
  styleUrls: ['../../../scss/vendors/toastr/toastr.scss'],
  templateUrl: './app-bugreporting.component.html'
})
export class AppBugreportingComponent { 

  modalRef: BsModalRef;
  bugTypes = BugTypes;  //populates list of bug types
  bugForm: FormGroup;
  bug: Bug;
  userId: string;
  

  constructor(
    private modalService: BsModalService,
    private fb: FormBuilder,
    private toastr: ToasterService,
    private db: AngularFirestore,
    private authService: AuthService
  ) {   }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,{class:'modal-md'});
  }

  closeModal(){
    this.modalRef.hide();
    this.bugForm.reset();
  }

  ngOnInit(){        
    this.toastr.clear();
    this.userId = this.authService.uid;
    this.buildForms();
  }

  submitBug(){
    this.toastr.clear();
    if(this.bugForm.invalid){
      if(!this.bugForm.value.bugType){
        this.toastr.pop('error','Error', 'A bug type must be selected');   
        return;
      }
      if(!this.bugForm.value.bugDetails){
        this.toastr.pop('error','Error', 'Please detail the bug you experienced');    
        return;
      }  
    } else {
      this.bugForm.patchValue({
        dateSubmitted: firebase.firestore.Timestamp.fromDate(new Date()),
        userWhoSubmitted: this.authService.uid
      })
      this.db.collection('bugReports').add(this.bugForm.value)
      .then( 
       sucsess => this.toastr.pop('success','Success','Your bug has been submitted and will be reviewed as soon as possible.')
      ,error => this.toastr.pop('error','Error','Unable to post bug reports at this time'));
    }
    this.closeModal();
    this.bugForm.reset();
  }

  private buildForms() {
    this.bugForm = this.fb.group({
      'bugType': ['',[
          Validators.required
      ]],
      'bugDetails':['',[
          Validators.required
      ]],
      'dateSubmitted': firebase.firestore.Timestamp.fromDate(new Date()),
      'userWhoSubmitted': this.authService.uid
    })
  } 

}



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-bugreporting/app-bugreporting.component.ts